
const WebGL1VertRules = {
  "VERT_IN"  : "attribute",
  "VERT_OUT" : "varying",
};

const WebGL1FragRules = {
  "FRAG_IN"            : "varying",
  "FRAG_DEF_OUT[0-9]+" : "",
  "FRAG_DEF_OUT"       : "",
  "FRAG_OUT[0-9]+"     : "gl_FragData[X]",
  "FRAG_OUT"           : "gl_FragColor",
  "SAMPLER2D"          : "texture2D",
  "SAMPLER_CUBE"       : "textureCube",
  "SAMPLER_LOD_CUBE"   : "textureCubeLodEXT",
  "DEPTH_OUT"          : "gl_FragDepthEXT"
};

const WebGL2VertRules = {
  "VERT_IN"  : "in",
  "VERT_OUT" : "out",
};

const WebGL2FragRules = {
  "FRAG_IN"            : "in",
  "FRAG_DEF_OUT[0-9]+" : "layout(location=X) out vec4 out_colorX;\n",
  "FRAG_DEF_OUT"       : "out vec4 out_color;\n",
  "FRAG_OUTX"          : "out_colorX",
  "FRAG_OUT"           : "out_color",
  "SAMPLER2D"          : "texture",
  "SAMPLER_CUBE"       : "texture",
  "SAMPLER_LOD_CUBE"   : "textureLod",
  "DEPTH_OUT"          : "gl_FragDepth"
};

function applyRules(shaderText, rules) {

  for (let rule in rules) {

    const replacement = rules[rule];
    var regex = new RegExp(rule, "g");

    shaderText = shaderText.replace(regex, (match) => {
      const number = match.match(/\d+(?=$)/g);
      return number ? replacement.replace(/X/g, number[0]) : replacement;
    });

  }

  return shaderText;

}


export default {

  castVShaderToWebGL1 : function(shaderText) {
    return applyRules(shaderText, WebGL1VertRules);
  },

  castFShaderToWebGL1 : function(shaderText) {
    return applyRules(shaderText, WebGL1FragRules);
  },

  castVShaderToWebGL2 : function(shaderText) {
    return applyRules(shaderText, WebGL2VertRules);
  },

  castFShaderToWebGL2 : function(shaderText) {
    return applyRules(shaderText, WebGL2FragRules);
  },

  applyCustomRules: function(shaderText, customRules) {
    return applyRules(shaderText, customRules);
  }

}
